import { IAppAction, ActionType } from "../actions/Helpers";
import { IAlert } from "src/redux/state/Alert";

export interface IModalState {
  data?: IAlert | null;
}

export interface IRootModalState {
  root?: IModalState;
  timeline?: IModalState;
}

const defaultState: IModalState = {
  data: null,
};

const defaultRootModalStates: IRootModalState = {
  root: defaultState,
  timeline: defaultState,
};

export const ModalReducer = (state = defaultRootModalStates, action: IAppAction): IRootModalState => {
  switch (action.type) {
    case ActionType.OPEN_MODAL:
      return { ...state, ...action.payload };
    case ActionType.CLOSE_MODAL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
